import Choice from './Choice';
import Combinations from './Combinations';
import Contact from './Contact';
import Design from './Design';
import Features from './Features';
import Intro from './Intro';
import Technology from './Technology';

export { Choice, Combinations, Contact, Design, Features, Intro, Technology };
